import React, { useState, useRef } from 'react'
import useOnClickOutside from '../hooks/useOnClickOutside'
import { Link } from 'gatsby'

const Dropdown = (props) => {
  const ref = useRef()
  const [isOpen, setOpen] = useState(false)
  const dropdownToggle = () => setOpen(!isOpen)

  useOnClickOutside(ref, () => setOpen(false))

  return (
    <li ref={ref}>
      <button
        aria-expanded={isOpen}
        aria-haspopup='true'
        className='inline-flex w-full cursor-pointer items-center py-4 px-4 text-lg transition duration-150 ease-in-out hover:text-orange-500 focus:bg-gray-100 focus:outline-none focus:ring sm:text-base lg:w-auto lg:px-2 lg:pt-6'
        onClick={dropdownToggle}
        onKeyDown={dropdownToggle}>
        {props.children}
        <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5 text-orange-500' height='1em' width='1em'>
          <path d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' fill='currentColor' />
          <path d='M0 0h24v24H0z' fill='none' />
        </svg>
      </button>
      <ul
        className={`${
          isOpen
            ? 'whitespace-no-wrap left-0 left-auto right-auto grid w-full grid-cols-2 gap-1 bg-gray-100 px-2 pb-4 text-left text-lg sm:absolute sm:mb-0 sm:text-base md:grid-cols-3 lg:mb-16 lg:w-auto lg:grid-flow-col lg:grid-cols-none lg:p-4 lg:shadow-xl'
            : 'hidden'
        } ${props.items.length > 5 ? 'lg:grid-rows-6' : `lg:grid-rows-${props.items.length}`}`}>
        {props.items.map((subNav, index) => {
          return (
            <li className='m-1 lg:mx-0' key={`subNav-${index}`}>
              <Link
                className='block py-2 px-3 transition duration-150 ease-in-out hover:bg-orange-100 hover:text-orange-500 focus:outline-none focus:ring'
                activeClassName='active'
                to={subNav.sub_nav_link.url}>
                {subNav.sub_nav_link_label}
              </Link>
            </li>
          )
        })}
      </ul>
    </li>
  )
}

export default Dropdown
